import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const newSimulationService = async ({ orderId, body }) => {
  try {
    const { data } = await axios.post(
      `/api/orders/${orderId}/simulation`,
      body
    );
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? UNKNOWN_ERROR);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { newSimulationService };
